export default __webpack_public_path__ + "static/media/49_mobile.4435527e.jpg";